import { NS } from "../../static/constants";

// ----------------

export const RESTORE_DEFAULT_STATE = `${NS}/RESTORE_DEFAULT_STATE`;
